export const MIN_THRESHOLD_MET_TITLE = 'Minimum Threshold Met';

const CLIENTS_MARKER = /^(.*?interested clients:\s*)(.*)$/i;

/** Formats Minimum Threshold Met body so each interested client is a bullet, with WM/RM kept on that line. */
export function formatMinThresholdNotificationMessage(
    title: string | null | undefined,
    message: string | null | undefined,
): string {
    const rawMessage = message ?? '';
    if (!isMinThresholdMetTitle(title) || !rawMessage) {
        return rawMessage;
    }

    const markerMatch = rawMessage.match(CLIENTS_MARKER);
    if (!markerMatch) {
        return rawMessage;
    }

    const prefix = markerMatch[1].trim();
    const listPart = markerMatch[2].trim().replace(/[.\s]+$/, '');
    const clients = parseInterestedClients(listPart);
    if (clients.length === 0) {
        return rawMessage;
    }

    const items = clients.map((client) => `• ${escapeHtml(client)}`).join('<br>');
    return `${escapeHtml(prefix)}<br>${items}`;
}

export function isMinThresholdMetTitle(title: string | null | undefined): boolean {
    return (title ?? '').trim() === MIN_THRESHOLD_MET_TITLE;
}

function parseInterestedClients(listPart: string): string[] {
    if (!listPart) {
        return [];
    }

    const cleaned = listPart.replace(/[.\s]+$/, '');
    const matches = cleaned.match(/[^,()]+(?:\s*\([^)]*\))?/g);
    if (!matches) {
        return [];
    }

    return matches.map((client) => client.trim()).filter(Boolean);
}

function escapeHtml(value: string): string {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
